import { Context, MethodType } from '@bit/gerenciatd.utils.types';
import Request, { getMockedInfo } from '@bit/gerenciatd.utils.request';
import FrontSonda from '@bit/gerenciatd.utils.front-sonda';

enum PATHS {
  GET_FOOTER_INFO = '/static/json/footer/footer.json',
  GET_FOOTER_INFO_EMP = '/static/json/footer/footerEmp.json',
  GET_HEADER_INFO = '/static/json/header/header.json',
  GET_HEADER_INFO_EMP = '/static/json/header/headerEmp.json',
  GET_CONSTANTS_INFO_EMP = '/static/json/constants/constantsEmp.json',
}

export const errorDetected = (sonda: FrontSonda): null => {
  sonda.errorMessage({
    info: `Ha fallado la petición al json: ${sonda.processName}`,
  });
  return null;
};

export const getFooterInfo = (context: Context): Promise<unknown> => {
  const myFrontSonda = new FrontSonda({
    processName: 'MISCELLANEOUS.GET_FOOTER_INFO',
    context,
    filePath: 'sagas/footer',
  });
  const { bucket: connectionData } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { name: envName } = context.environment;

  const URL_API = `${host}${PATHS.GET_FOOTER_INFO}`;
  const mockInfo = getMockedInfo('getFooterInfo', envName);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onError: () => errorDetected(myFrontSonda),
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    myFrontSonda.errorMessage({
      error: err,
      info: 'Ha fallado js durante la invocación al json',
    });
    return null;
  }
};

export const getFooterInfoEmp = (context: Context): Promise<unknown> => {
  const myFrontSonda = new FrontSonda({
    processName: 'MISCELLANEOUS.GET_FOOTER_INFO_EMP',
    context,
    filePath: 'sagas/footer',
  });

  const { bucket: connectionData } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { name: envName } = context.environment;

  const URL_API = `${host}${PATHS.GET_FOOTER_INFO_EMP}`;
  const mockInfo = getMockedInfo('getFooterInfoEmp', envName);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onError: () => errorDetected(myFrontSonda),
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    myFrontSonda.errorMessage({
      error: err,
      info: 'Ha fallado js durante la invocación al json',
    });
    return null;
  }
};

export const getHeaderInfo = (context: Context): Promise<unknown> => {
  const myFrontSonda = new FrontSonda({
    processName: 'MISCELLANEOUS.GET_HEADER_INFO',
    context,
    filePath: 'sagas/header',
  });

  const { bucket: connectionData } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { name: envName } = context.environment;

  const URL_API = `${host}${PATHS.GET_HEADER_INFO}`;
  const mockInfo = getMockedInfo('getHeaderInfo', envName);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onError: () => errorDetected(myFrontSonda),
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    myFrontSonda.errorMessage({
      error: err,
      info: 'Ha fallado js durante la invocación al json',
    });
    return null;
  }
};

export const getHeaderInfoEmp = (context: Context): Promise<unknown> => {
  const myFrontSonda = new FrontSonda({
    processName: 'MISCELLANEOUS.GET_HEADER_INFO_EMP',
    context,
    filePath: 'sagas/header',
  });

  const { bucket: connectionData } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { name: envName } = context.environment;

  const URL_API = `${host}${PATHS.GET_HEADER_INFO_EMP}`;
  const mockInfo = getMockedInfo('getHeaderInfoEmp', envName);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onError: () => errorDetected(myFrontSonda),
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    myFrontSonda.errorMessage({
      error: err,
      info: 'Ha fallado js durante la invocación al json',
    });
    return null;
  }
};

export const getConstantsInfoEmp = (context: Context): Promise<unknown> => {
  const myFrontSonda = new FrontSonda({
    processName: 'MISCELLANEOUS.GET_CONSTANTS_INFO_EMP',
    context,
    filePath: 'sagas/header',
  });

  const { bucket: connectionData } = context.environment;
  const { endpoint: host, headers } = connectionData;
  const { name: envName } = context.environment;

  const URL_API = `${host}${PATHS.GET_CONSTANTS_INFO_EMP}`;
  const mockInfo = getMockedInfo('getConstantsInfoEmp', envName);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onError: () => errorDetected(myFrontSonda),
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    myFrontSonda.errorMessage({
      error: err,
      info: 'Ha fallado js durante la invocación al json',
    });
    return null;
  }
};
